<template>
    <div class="explore-header-area h-offset">
        <form
            class="inner container"
            autocomplete="off"
            @submit.prevent="submitKeywords"
        >
            <h1 class="font-lgr font-castoro">
                <span v-if="!!user" :class="{capitalize: !metaLabel}">Hi {{ user.first_name }}</span><span v-if="!!user && metaLabel">, </span>
                <span v-if="metaLabel">
                    We've Found {{ metaCount }} Perfect
                    <span class="fg-primary"> {{ metaLabel }}</span> Space{{
                        metaCount == 1 ? "" : "s"
                    }}</span>
            </h1>
            <div class="row flex-group flex-wrap">
                <div class="inline-search-elements">
                    <div class="inner">
                        <!-- <keyword-search
                ref="keywordSearch"
                placeholder="I'm searching for..."
                @selected="handleKeywordSelection"
                @input="input => this.keywordsInput = input"
            ></keyword-search> -->

                        <div class="search-form-tags has-flyout element flex-1">
                            <div class="tag-search">
                                <select-wrapper
                                    labelText="Search by collection"
                                    id="listing-collection"
                                    :appendToBody="appendToBody"
                                    placeholder="Select all that apply"
                                    :multiple="multiple"
                                    name="collections"
                                    :options="collections"
                                    option-key="slug"
                                    v-model="filters.collections"
                                >
                                </select-wrapper>
                            </div>
                        </div>

                        <location-search
                            :initial-value="locationRepopulateValue"
                            :external-selection="keywordSearchLocation"
                            placeholder-text="Enter state, suburb or city name"
                            @input="setLocationFilter"
                            @clear="clearLocationFilter"
                        ></location-search>
                    </div>
                </div>
                <div id="filters-advanced" class="element">
                    <div
                        class="filter-trigger static"
                        :class="{ active: hasMoreFilters }"
                        @click="showAdvancedFilters"
                    >
                        <div class="label">
                            FILTER <svg-icon id="filter"></svg-icon>
                        </div>
                    </div>
                </div>
                <div class="element toggle-map">
                    <button
                        type="button"
                        class="button transparent trigger show-map"
                        @click="toggleMap"
                    >
                        <span>{{ !showMap ? "Show" : "Hide" }} Map</span>
                        <svg-icon id="toggleMap"></svg-icon>
                    </button>
                </div>
                <div
                    class="element tags-selected"
                    :class="{ populated: filters.keywords.length }"
                >
                    <ul class="listing tag-input-options removable">
                        <li
                            v-if="typeof filters.keywords !== 'undefined'"
                            v-for="(keyword, index) in filters.keywords"
                        >
                            <span>{{ keyword }}</span>
                            <svg-icon
                                id="cross"
                                class="remove"
                                @click.native="removeKeyword(index)"
                            ></svg-icon>
                        </li>
                    </ul>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import "vue-slider-component/theme/antd.css";

import cloneDeep from "lodash/cloneDeep";
import debounce from "lodash/debounce";
import isEqual from "lodash/isEqual";
import merge from "lodash/merge";
import VueSlider from "vue-slider-component";

export default {
    components: {
        VueSlider,
    },
    props: {
        currentPage: {
            type: Number,
            default: 1,
        },
        productionTypes: {
            type: Array,
            required: true,
        },
        propertyTypes: {
            type: Array,
            required: true,
        },
        budgetRange: {
            type: Array,
            required: true,
        },
        metaCount: {
            type: Number,
        },
        metaCounts: {
            type: Object,
        },
        metaLabel: {
            type: String,
        },
        rateDayFrom: {
            type: Number,
        },
        rateDayTo: {
            type: Number,
        },
        capacity: {
            type: Number,
        },
    },
    mounted() {
        this.propFilters();
        this.$emit("filtersChanged", this.filters);

        this.$eventBus.$on(
            "selectLocation",
            (location) => (this.selectedLocation = location)
        );

        window.addEventListener("click", this.delegatedHideFilters);
    },
    beforeDestroy() {
        // Remove the window clicky delegated event
        window.removeEventListener("click", this.delegatedHideFilters);
    },
    data() {
        const filters = {
            keywords: [],
            location: null,
            location_name: null,
            radius: 2,
            budget: this.budgetRange, // TODO this should be deprecated properly sometime
            production_types: [], // TODO this should be deprecated properly sometime
            property_types: [], // TODO this should be deprecated properly sometime
            availabilityTypes: [],
            propertyTypes: [],
            spaceTypes: [],
            rateDayFrom: null,
            rateDayTo: null,
            capacity: null,
            collections: [],
            metaCounts: null
        };

        return {
            keywordsInput: "",
            location: "",
            selectedLocation: null,
            selectedLocationType: null,
            locations: [],
            collections: [],
            multiple: true,
            appendToBody: true,
            locationSearchFocused: false,
            watchFilters: false,
            //requiresUrlReset: this.filterMeta,
            requiresUrlReset: false,
            urlSearchParams: new URLSearchParams(
                new URL(window.location.href).search
            ),
            filters,
            defaultFilters: cloneDeep(filters),
            visibleFilter: null,
            keywordSearchLocation: {
                location: null,
                name: null,
                type: null,
            },
        };
    },
    mounted() {
        this.fetchCollections();
        this.propFilters();
    },

    methods: {
        propFilters() {
            let keywords = [];

            for (let keyword of this.urlSearchParams.getAll("keywords")) {
                if (keyword.length) {
                    keywords.push(decodeURIComponent(keyword));
                }
            }

            const meta = {
                keywords: keywords.length ? keywords : null,
                location: decodeURIComponent(
                    this.urlSearchParams.get("location")
                ),
                location_name: decodeURIComponent(
                    this.urlSearchParams.get("location-name")
                ),
                radius: parseInt(this.urlSearchParams.get("radius")) || 2,
                budget: this.urlSearchParams.getAll("budget"),
            };

            if (this.urlSearchParams.get("production-types")) {
                meta["production_types"] =
                    this.urlSearchParams.getAll("production-types");
            }

            if (this.urlSearchParams.get("collections")) {
                meta["collections"] = this.urlSearchParams.getAll("collections");
                this.filters.collections = meta["collections"];
            }

            if (this.urlSearchParams.get("property-types")) {
                meta["property_types"] =
                    this.urlSearchParams.getAll("property-types");
            }

            if (this.urlSearchParams.get("rateDayFrom")) {
                meta["rateDayFrom"] = this.urlSearchParams.get("rateDayFrom");
                this.filters.rateDayFrom = meta["rateDayFrom"];
            }

            if (this.urlSearchParams.get("rateDayTo")) {
                meta["rateDayTo"] = this.urlSearchParams.get("rateDayTo");
                this.filters.rateDayTo = meta["rateDayTo"];
            }

            if (this.urlSearchParams.get("capacity")) {
                meta["capacity"] = this.urlSearchParams.get("capacity");
                this.filters.capacity = meta["capacity"];
            }

            if (this.urlSearchParams.get("metaCounts")) {
                meta["metaCounts"] = JSON.parse(this.urlSearchParams.get("metaCounts"));
                this.filters.metaCounts = meta["metaCounts"];
            }

            let advanced = ["availabilityTypes", "propertyTypes", "spaceTypes"];

            for (let prop of advanced) {
                let value = this.urlSearchParams.getAll(prop);

                if (value && value.length) {
                    meta[prop] = [];

                    for (let x = 0; x < value.length; x++) {
                        meta[prop].push(parseInt(value[x]));
                    }
                }
            }

            for (const [key, value] of Object.entries(meta)) {
                if (value && value !== "null") {
                    this.filters[key] = value;
                }
            }

            if (meta.location && meta.location_name) {
                let parts = meta.location.split(":");

                if (parts[1]) {
                    this.selectedLocation = meta.location_name;
                    this.selectedLocationType = parts[0];
                }
            }

            this.$eventBus.$emit("propFilters", this.filters);

            for (let i = 0; i <= 1; i++) {
                this.filters.budget[i] = this.filters.budget[i]
                    ? parseInt(this.filters.budget[i])
                    : this.budgetRange[i];
            }
        },
        showAdvancedFilters() {
            this.$store
                .dispatch("modals/show", {
                    title: "More Filters",
                    type: "listing-advanced-filters",
                    data: this.currentExtraFilters,
                    wide: true
                })
                .then((resolved) => {
                    for (let prop in resolved.related) {
                        this.$set(this.filters, prop, resolved.related[prop]);
                    }
                    merge(this.filters, resolved.related);
                });
        },
        locationIcon(result) {
            switch (result.type) {
                case "lga":
                    return "tentMoon";
                case "region":
                    return "toggleMap";
            }

            return "mapPin";
        },
        resetLocationSearch() {
            this.selectedLocation = "";
            this.selectedLocationType = null;
            this.filters.location = "";
            this.filters.location_name = "";
        },
        toggleFilter(filter, item) {
            const i = this.filters[filter].findIndex(
                (slug) => slug === item.slug
            );
            if (i !== -1) {
                return this.filters[filter].splice(i, 1);
            }
            this.filters[filter].push(item.slug);
        },
        isActive(filter, item) {
            if (
                typeof this.filters[filter] === "undefined" ||
                !this.filters[filter].length
            ) {
                return false;
            }
            return (
                this.filters[filter].findIndex((slug) => slug === item.slug) !==
                -1
            );
        },
        getFilterLabel(prop, filter, defaultLabel) {
            if (
                typeof this[prop] !== "undefined" &&
                this[prop] &&
                this[prop].length
            ) {
                let a = this[prop].filter((meta) => {
                    if (!Array.isArray(this.filters[filter])) {
                        return this.filters[filter] === meta.slug;
                    }
                    return (
                        this.filters[filter].findIndex(
                            (type) => type === meta.slug
                        ) !== -1
                    );
                });
                if (a.length) {
                    //return a.map(meta => meta.label).join(', ')

                    if (a.length > 1) {
                        return a[0].label + " (+" + (a.length - 1) + ")";
                    }

                    return a[0].label;
                }
            }
            return defaultLabel;
        },
        submitKeywords() {
            if (this.keywordsInput !== "") {
                this.filters.keywords.push(this.keywordsInput);
                this.keywordsInput = "";
                this.$refs.keywordSearch.$emit("clear");
            }
            if (this.filters.collections?.length > 0) {
                this.$emit("filtersChanged", this.filters);
            }
        },
        removeKeyword(index) {
            this.filters.keywords.splice(index, 1);
        },

        fetchCollections() {
            axios
                .get("/api/form-meta/collections")
                .then((response) => {
                    this.collections = response.data || [];
                })
                .catch((error) => {});
        },

        fetchLocations() {
            if (!this.location || this.location === "") {
                return;
            }
            axios
                .get("/api/locations", {
                    params: {
                        query: this.location,
                    },
                })
                .then((response) => {
                    this.locations = response.data || [];
                })
                .catch((error) => {
                });
        },
        setLocationFilter(result) {
            this.filters.location = result.location;
            this.filters.location_name = result.name;
            this.filters.radius = result.radius;
            this.submitKeywords();
        },
        clearLocationFilter() {
            this.filters.location = null;
            this.filters.location_name = null;
        },
        setLocation(result) {
            this.filters.location = result.type + ":" + result.id;
            this.filters.location_name = result.label;
            this.selectedLocation = result.label;
            this.selectedLocationType = result.type;
            this.location = "";
            this.locations = [];
        },
        clearSelectedLocation() {
            this.filters.location = null;
            this.selectedLocation = null;
        },
        clearFilters() {
            this.filters = this.defaultFilters;
        },
        hoverFilter(which) {
            if (this.visibleFilter !== which) {
                this.visibleFilter = null;
            }
        },
        toggleVisibleFilter(which) {
            this.visibleFilter = this.visibleFilter === which ? null : which;
        },
        delegatedHideFilters(e) {
            if (!e.target.closest(".element")) {
                this.visibleFilter = null;
            }
        },
        toggleMap() {
            this.$store.commit("listings/toggleMap");
        },
        updateFilterData() {
            const urlSearchParams = new URLSearchParams();

            if (this.filters) {
                if (this.requiresUrlReset) {
                    window.history.replaceState({}, "", "/explore");
                    this.requiresUrlReset = false;
                }

                for (const [key, value] of Object.entries(this.filters)) {
                    let seo_key = key.replace("_", "-");

                    if (Array.isArray(value)) {
                        if (isEqual(value, this.defaultFilters[key])) {
                            continue;
                        }
                        value.forEach((v, i) => {
                            if (
                                v === false ||
                                v === null ||
                                v === "null" ||
                                v === ""
                            ) {
                                urlSearchParams.delete(seo_key);
                                return;
                            }

                            urlSearchParams.append(seo_key, v);
                        });
                        continue;
                    }

                    if (
                        !value ||
                        value === "" ||
                        value === "null" ||
                        (key === "radius" && parseInt(value) === 2)
                    ) {
                        urlSearchParams.delete(seo_key);
                        continue;
                    }
                    if (typeof value === 'object') {
                      urlSearchParams.set(seo_key, JSON.stringify(value));
                    } else {
                      urlSearchParams.set(seo_key, value);
                    }
                }
            }

            if (this.currentPage > 1) {
                urlSearchParams.append("page", this.currentPage);
            }

            window.history.pushState(
                {},
                "",
                location.pathname +
                    (urlSearchParams.toString() ? `?${urlSearchParams}` : "")
            );

            if (this.filters.collections || this.filters.location_name) {
              this.$store.dispatch("intercom/track", {
                type: "Search Button",
                meta: {
                  categories: this.filters.collections,
                  location: this.filters.location_name
                }
              });
              console.log('Intercom New: Search Button', {categories: this.filters.collections, location: this.filters.location_name});
            }
        },

        handleKeywordSelection(keyword) {
            if (keyword.type === "keyword") {
                this.filters.keywords.push(keyword.value);
            } else {
                this.keywordSearchLocation = keyword;
            }
        },
    },
    watch: {
        location: debounce(function () {
            if (
                (this.locationIsActive && this.location === "") ||
                this.location.length < 3
            ) {
                return;
            }
            this.fetchLocations();
        }, 250),
        currentPage() {
            this.updateFilterData();
        },
        filters: {
            deep: true,
            //handler: debounce(function () {
            handler() {
                if (!this.watchFilters) {
                    this.watchFilters = true;
                    return;
                }
                this.updateFilterData();
                this.$emit("filtersChanged", this.filters);
            },
        },
    },
    computed: {
        formattedBudgets() {
            return [
                "$" + Intl.NumberFormat().format(this.filters.budget[0] / 100),
                "$" + Intl.NumberFormat().format(this.filters.budget[1] / 100),
            ];
        },
        locationIsActive() {
            return !!this.selectedLocation;
        },
        locationRepopulateValue() {
            if (
                this.urlSearchParams.get("location") &&
                this.urlSearchParams.get("location-name")
            ) {
                let parts = this.urlSearchParams.get("location").split(":");

                return {
                    location: this.urlSearchParams.get("location"),
                    name: this.urlSearchParams.get("location-name"),
                    type: parts[0],
                    radius: parseInt(this.urlSearchParams.get("radius")) || 2,
                };
            }

            return null;
        },
        hasLocationSearchTerm() {
            return this.location.length > 0;
        },
        requiresLocationRadius() {
            return this.selectedLocationType === "place";
        },
        showMap() {
            return this.$store.getters["listings/showMap"];
        },
        budgetIsActive() {
            return (
                this.filters.budget[0] !== this.budgetRange[0] ||
                this.filters.budget[1] !== this.budgetRange[1]
            );
        },
        budgetLabel() {
            if (this.budgetIsActive) {
                return `${this.filters.budget[0]} to ${this.filters.budget[1]} per day`;
            }
            return "Budget";
        },
        selectedBudgetLabel() {
            if (
                this.filters.budget[0] > 0 &&
                this.filters.budget[1] < this.budgetRange[1]
            ) {
                return `${this.formattedBudgets[0]} to ${this.formattedBudgets[1]} per day`;
            } else if (this.filters.budget[0] > 0) {
                return `Over ${this.formattedBudgets[0]} per day`;
            } else if (this.filters.budget[1] < this.budgetRange[1]) {
                return `Under ${this.formattedBudgets[1]} per day`;
            }

            return null;
        },
        currentExtraFilters() {
            return {
                availabilityTypes: this.filters.availabilityTypes,
                propertyTypes: this.filters.propertyTypes,
                spaceTypes: this.filters.spaceTypes,
                rateDayFrom: this.filters.rateDayFrom,
                rateDayTo: this.filters.rateDayTo,
                capacity: this.filters.capacity,
                metaCounts: this.filters.metaCounts,
            };
        },
        extraIterableFilters() {
            let ids = [];

            for (let prop in this.currentExtraFilters) {
              if (Array.isArray(this.currentExtraFilters[prop])) {
                ids = ids.concat(this.currentExtraFilters[prop]);
              }
            }

            return ids;
        },
        hasMoreFilters() {
            return this.extraIterableFilters.length > 0 || this.filters.rateDayFrom || this.filters.rateDayTo || this.filters.capacity;
        },
        user () {
            return this.$store.getters['user/account']
        },
    },
};
</script>
